module.exports = __webpack_public_path__ + "assets/img/alert.523f2b30.svg";